import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "search-input-container" }
const _hoisted_2 = { class: "search-input-container__input-wrapper" }
const _hoisted_3 = ["input"]
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "search-input-container__suggestion-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconSearch = _resolveComponent("IconSearch")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconSearch, { class: "search-input-container__search-icon" }),
      _createElementVNode("input", {
        input: _ctx.searchInput,
        role: "search",
        placeholder: "Search...",
        class: "search-input-container__search-input",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInputChange($event.target.value))),
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInputBlur && _ctx.onInputBlur(...args)))
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (suggestion) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: suggestion.id,
            to: _ctx.linkToEntity(suggestion),
            class: "search-input-container__suggestion-list__suggestion-list-item"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {
                suggestion: suggestion,
                clearInput: _ctx.clearInput
              }, undefined, true)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ])
    ])
  ]))
}